import {
  OPERATOR_GROUP_FETCH_REQUEST,
  OPERATOR_GROUP_FETCH_REQUEST_SUCCESS,
  OPERATOR_GROUP_FETCH_REQUEST_FAILURE,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const operatorGroupsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case OPERATOR_GROUP_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case OPERATOR_GROUP_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case OPERATOR_GROUP_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    default:
      return state;
  }
};

export default operatorGroupsReducer;
